(function($) {
  $(document).ready(function() {
    const cityData = {
      andhrapradesh: {
        Rajahmundry: {
          name: "Gayatri Infotech",
          address: "8 18 54/5, kvn building, kambham choultry street,rajahmundry,east godavari, andhra pradesh, 533101",
          phone: "1800 123 8195 / 9866224317",
          email: "inquiry@artis.in"
        }
      },
      assam: {
        Guwahati: {
          name: "Mahalaxmi Infotronics Systems",
          address: "Hg Complex, 2nd Floor, House No 2, Solapara Road, Paltan Bazar, Guwahati - 761008",
          phone: "1800 123 8195 / 7875012381",
          email: "inquiry@artis.in"
        }
      },
      chhattisgarh: {
        Raipur: {
          name: "Kunhar Peripherals Pvt Ltd.",
          address: "-",
          phone: "1800 123 8195 / 9340948647",
          email: "inquiry@artis.in"
        }
      },
      bihar: {
        Patana: {
          name: "Ambika telecom",
          address: "shop 10, jamal road, saket plaza, patna – bihar -800001",
          phone: "1800 123 8195 / 9835033871 / 8409423333",
          email: "inquiry@artis.in"
        }
      },
      goa: {
        Panjim: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "Shop No 12,13,14, Building No 8, Rosari Apt., St. Mary Colony, Miramar, Panjim Goa - 403001",
          phone: "1800 123 8195 / 9158444875",
          email: "inquiry@artis.in"
        },
        Madgaon: {
          name: "Digi-serve (franchise)",
          address: "Shop no-c 1   kartik enclave opposite, vaibhav park  behind pai palace, hotel borda margao, goa 403601, 403601",
          phone: "1800 123 8195 / 9822983736 / 7588118191",
          email: "inquiry@artis.in"
        }
      },
      gujarat: {
        Ahmedabad: {
          name: "Kunhar Peripherals Pvt.Ltd.",
          address: "5, Goyal Enter City Row House, Opp. Doordarshan Tower, Off Drive-inn Road, Thaltej, Ahmedabad - 380054",
          phone: "1800 123 8195 / +91 9099084737",
          email: "inquiry@artis.in"
        },
        Rajkot: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "307, 3rd Floor, Krishna Conarch, Opp. Hanuman Temple, Near Godown Road, Tagore Road, Rajkot - 360002",
          phone: "1800 123 8195 / 9925239847",
          email: "inquiry@artis.in"
        },
        Surat: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "Artis Service Centre, First floor, Pran Prabha building, Opp Kailsh Sweets, Nanpura, Surat - 395001",
          phone: "1800 123 8195 / 0261-3101773 / 0261-2470238",
          email: "inquiry@artis.in"
        },
        Vadodara: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "218, Lalita Tower, Behind Railway Station, Alkapuri, Baroda - 390007",
          phone: "1800 123 8195 / 9925046737",
          email: "inquiry@artis.in"
        }
      },
      karnataka: {
        Bangalore: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "# 3/21, 2nd Floor, New Raja Building, N.R. Road. Bengaluru 560002",
          phone: "1800 123 8195 / 9844308041/ 8209866752 ",
          email: "inquiry@artis.in"
        },
        Belgaum: {
          name: "Shri manisha marketing (franchise)",
          address: "# 1874 /A, BAPAT GALLI, BELGAUM, 590002",
          phone: "1800 123 8195 / 9739516213",
          email: "inquiry@artis.in"
        },
        Hubli: {
          name: "Kunhar Peripherals Pvt.Ltd.",
          address: "118, First Floor, Shrinath Complex, New Cotton Market, Hubli - 580029",
          phone: "1800 123 8195 / 9353628704",
          email: "inquiry@artis.in"
        },
        Mangalore: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "NO.4-2-265/5,Ganesh Prasad apartment Near. City Arena ground 6th cross. Kodialguttu Mangalore -575003",
          phone: "1800 123 8195 / 9880524153",
          email: "inquiry@artis.in"
        },
        Mysore: {
          name: "Arihant Infotech  (Franchise)",
          address: "#3, Hamilton Building, Ashoka Road, Mysore - 570001",
          phone: "1800 123 8195 / 9632741784",
          email: "inquiry@artis.in"
        }
      },
      kerala: {
      Kannur: {
          name: "Ideal Solution (franchise)",
          address: "3rd floor, topland grand bazer complex bellard road kannur kerala -670001",
          phone: "1800 123 8195 / 8129059275",
          email: "inquiry@artis.in"
        },
        Kochi: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "Pazhumalil House, 54/2887, Temple Road kadavanthra P.O Kochi-682020.",
          phone: "1800 123 8195 / 9447152545",
          email: "inquiry@artis.in"
        },
        Palakkad: {
          name: "Infra Technologies (franchise)",
          address: "1st floor, v&v apartment, near karur vysya bank, vellan street, sulthanpet, palakkad – 678001",
          phone: "1800 123 8195 / 9446054030",
          email: "inquiry@artis.in"
        }
      },
      madhyapradesh: {
        Indore: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "205-A Silver Mall, RNT marg, Indore – MP Pin code : 452001",
          phone: "1800 123 8195 / 9826594974 / 9981949522",
          email: "inquiry@artis.in"
        }
      },
      maharashtra: {
        Amravati: {
          name: "Kunhar Peripherals Pvt Ltd.",
          address: "Mahaveer Nagar, Near Hanuman Temple, Badner Road, Amravati - 444607",
          phone: "1800 123 8195 / 9422236593",
          email: "inquiry@artis.in"
        },
        Andheri: {
          name: "Protech Computer (franchise)",
          address: "Shop No. 2, Shanti Kunj Bldg, Dawood Baug Lane, Near Kanakraj, Andheri (W)",
          phone: "1800 123 8195 / 9022960960 ",
          email: "inquiry@artis.in"
        },
        Aurangabad: {
          name: "MMS Computers And Multi Services (Franchise)",
          address: "Rathi Corner, Street Number 4, beside raj cloth, shop, Shahgunj, Aurangabad, Maharashtra 431001",
          phone: "1800 123 8195 / 8698558497",
          email: "inquiry@artis.in"
        },
        Borivali: {
          name: "Om sai enterprises",
          address: "Showroom no.5, Thakkar shopping mall, Opp Indraprastha,Boriwali west 400092",
          phone: "1800 123 8195 / 7304019086",
          email: "inquiry@artis.in"
        },
        Chandrapur: {
          name: "Kunhar Peripherals Pvt Ltd.",
          address: "-",
          phone: "1800 123 8195 / 7057700672 / 9326211421",
          email: "inquiry@artis.in"
        },
        Jalgaon: {
          name: "Kunhar Peripherals Pvt Ltd.",
          address: "-",
          phone: "1800 123 8195 / +91 8788942266",
          email: "inquiry@artis.in"
        },
        Kalyan: {
          name: "At your service (franchise)",
          address: "Shop no.18 a,zojwala complex,near hotel ramdev behind raymond showroom,sahajanand chowk, kalyan west-421301",
          phone: "1800 123 8195 / 9082980508",
          email: "inquiry@artis.in"
        },
        Kolhapur: {
          name: "Spectra Service",
          address: "947, B Tembe Road Opp Savitribai Phule Hospital Kolhapur 416012",
          phone: "1800 123 8195 / 0231-2641870 / 9850099456",
          email: "inquiry@artis.in"
        },
        Mumbai: {
          name: "Kunhar Peripherals Pvt Ltd.",
          address: "13/b, durlabh bhawan, off jalbhai road, grant road, (east), mumbai.,400004",
          phone: "1800 123 8195 / 022-23885711/12 / 9820136204",
          email: "inquiry@artis.in"
        },
        Nagpur: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "Plot No 131, Behind Raghatate Printing Press, Mehadia Sqr., Dhantoli, Nagpur - 440012",
          phone: "1800 123 8195 / 9595704095",
          email: "inquiry@artis.in"
        },
        Nashik: {
          name: "Audio Video Care (franchise)",
          address: "3, Maurya Apartment, Patil Lane, No 1,College Rd, Nashik, Maharashtra 422005",
          phone: "1800 123 8195 / 9923412336",
          email: "inquiry@artis.in"
        },
        Pimpri: {
          name: "S.P. Service Center",
          address: "Opp Raunak Hotel, Near Lassi ghar, Sai chowk,Pimpri Colony, Pimpri-Chinchwad 411017",
          phone: "1800 123 8195 / 7410744339 / 9552774339 ",
          email: "inquiry@artis.in"
        },
        Pune: {
          name: "Kunhar Peripherals Pvt Ltd.",
          address: "608, Munawar Manzil, Sachapir Street, Opp. Shitala Devi temple, Camp, Pune. ,411001",
          phone: "1800 123 8195 / 020-26113250/60 /7875012381",
          email: "inquiry@artis.in"
        },
        Ratnagiri: {
          name: "Nextstep Services (Franchise)",
          address: "Shop No.20, Samrat Shopping Center Maruti Mandir, Ratnagiri - 415612",
          phone: "1800 123 8195 / 9011099079 / 9923495251",
          email: "inquiry@artis.in"
        },
        Solapur: {
          name: "Kunhar Peripherals Pvt Ltd.",
          address: "-",
          phone: "1800 123 8195 / 7798880895",
          email: "inquiry@artis.in"
        },
        Thane: {
          name: "Kunhar Peripherals Pvt Ltd",
          address: "11, Ground floor, Nutan Parishram society,Shivaji nagar, B-cabin, Navpada, Thane (W), Mumbai 400062",
          phone: "1800 123 8195 / 9167875043",
          email: "inquiry@artis.in"
        },
        Vashi: {
          name: "Ideal Computers",
          address: "Office No. 452 D Wing, Second Floor Sector 17, Vashi Plaza Vashi, Navi Mumbai <br><b>Our office working hours are:</b><br>9:30 AM to 6:30 PM.<br><b>Customer visiting hours are:</b><br>Monday to Friday: 10:00 AM to 5:00 PM<br>Saturday: 10:00 AM to 3:00 PM",          
          phone: "022-49707338 / 9870089750",
          email: "inquiry@artis.in"
        },
        Virar: {
          name: "Mobile Master",
          address: "Shop-201, 2nd floor, Padmi Bai Tower, Opp. Railway subway, Manvel pada road, Virar (E) 401305",
          phone: "1800 123 8195 / 8108110202",
          email: "inquiry@artis.in"
        }
      },
      newdelhi: {
        Delhi: {
          name: "Kunhar Peripherals Pvt.Ltd",
          address: "C5 Padma Place,86 Nehru place 205, Second Floor cabin No, New Delhi-110019",
          phone: "1800 123 8195 / 8587944090",
          email: "inquiry@artis.in"
        }
      },
      rajasthan: {
         Alwar: {
          name: "Vinayak Computer and Mobile (franchise)",
          address: "Shop 5, Maa Vaishnavi Complex,Civil line hope circus, Alwar, Rajasthan 301001",
          phone: "1800 123 8195 / Mr. Vishnu +919351353066",
          email: "inquiry@artis.in"
        },
       Jaipur: {
          name: "GS communication (franchise)",
          address: "329 send four Doner House Indra bazar, Jaipur, Rajasthan, 302006",
          phone: "1800 123 8195 / 7737043114",
          email: "inquiry@artis.in"
        },
        Kota: {
          name: " Kay Kay Softech Pvt. Ltd. (franchise)",
          address: "342-B, Shopping Centre, KOTA - 324007",
          phone: "1800 123 8195 / 9929909444",
          email: "inquiry@artis.in"
        },
         Udaipur: {
          name: "My Services (franchise)",
          address: "33, F-road, Bhupalpura, Near J.K. Hospital, Udaipur (RAJ) 313001",
          phone: "1800 123 8195 / 9782989722 / 6350309922",
          email: "inquiry@artis.in"
        }
      },
      tamilnadu: {
        Chennai: {
          name: "Zian Marketing",
          address: "GF-2, Sri Balaji Complex, 21 Narasingampuram street, Mount road, Chennai 600002",
          phone: "1800 123 8195 / 7010066061 / 7010179979",
          email: "inquiry@artis.in"
        }
      },
      telangana: {
        Hyderabad: {
          name: "Jaswitha IT Needs & Solutions (franchise)",
          address: "607, 6th Floor, A Block, Chenoy Trade Center, Parklane, Secunderabad - 500003",
          phone: "1800 123 8195 / 9669848142120 ",
          email: "inquiry@artis.in"
        }
      },
      uttarpradesh: {
        Kanpur: {
          name: "Xarvis enterprises (franchise)",
          address: "House no. lig 229,gangapur kda colony, yashoda nagar,kanpur,kanpur, uttar pradesh,208011",
          phone: "1800 123 8195 / 8948005454",
          email: "inquiry@artis.in"
        },
        Lucknow: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "47/2, Prag Narain Road, Near Kalyan Bhawan, Lucknow-226001, U.P",
          phone: "1800 123 8195 / 8765433088",
          email: "inquiry@artis.in"
        },
        Varanasi: {
          name: "Remote care (franchise)",
          address: "d 64/29-k bank colony, madhopur sigra varanasi 221010 (u.p.)",
          phone: "1800 123 8195 / 9559042604",
          email: "inquiry@artis.in"
        }
      },
      uttarakhand: {
        Dehradun: {
          name: "Mangalam Marketing (franchise)",
          address: "Shop no 1-4, Ground floor, Maa Daat Complex,Chakhuwala, Dehradun,Uttrakhand-248001",
          phone: "1800 123 8195",
          email: "inquiry@artis.in"
        }
      },
      westbengal: {
        Kolkata: {
          name: "Kunhar Peripherals Pvt. Ltd.",
          address: "11, Khairu Place, Ground Floor, Near Bow Bazar Police station, Kolkata 700072",
          phone: "1800 123 8195 / 7003269081",
          email: "inquiry@artis.in"
        },
         Siliguri: {
          name: "Priya Infotech",
          address: "Third floor, shop no.14, international market, sevoke road, siliguri, darjeeling, west bengal, 734001",
          phone: "1800 123 8195 / 8918836198 / 9339067095",
          email: "inquiry@artis.in"
        }
      }
    };

    const $state = $('#stateDropdown');
    const $city = $('#cityDropdown');
    const $addressBox = $('#addressDisplay');

    $state.on('change', function() {
      const selectedState = $(this).val();
      $city.empty().append('<option value="">Select City*</option>');

      if (selectedState && cityData[selectedState]) {
        const cities = Object.keys(cityData[selectedState]);
        cities.forEach(city => {
          $city.append(`<option value="${city}">${city}</option>`);
        });
        $city.prop('disabled', false);
      } else {
        $city.prop('disabled', true);
      }

      $addressBox.empty();
    });

    $city.on('change', function() {
      const selectedState = $state.val();
      const selectedCity = $(this).val();

      if (selectedCity && cityData[selectedState] && cityData[selectedState][selectedCity]) {
        const data = cityData[selectedState][selectedCity];
        $addressBox.html(`
          <p><strong>${data.name}</strong></p>
          <p>${data.address}</p>
          <div class="call-deatils">
            <p><i class="fa-solid fa-phone-volume"></i><a href="tel:${data.phone}"> ${data.phone}</a></p>
            <p><i class="fa-regular fa-envelope"></i> <a href="mailto:${data.email}"> ${data.email}</a></p>
          </div>
        `);
      } else {
        $addressBox.empty();
      }
    });
  });
})(jQuery);
